import { ScenarioTemplateSet } from "components/scenarioManegement/ScenarioExpand/hook";

export const sampleScenario: ScenarioTemplateSet[] = [
  {
    scenario: { text: "項目1" },
    templates: [{ text: "テンプレート" }, { text: "テンプレート" }],
  },
  {
    scenario: { text: "項目2" },
    templates: [{ text: "テンプレート¥n改行テンプレート" }],
  },
];
